export enum FreezerActionTypes {
    SET_FREEZERS = 'freezers/setFreezers',
    LOADING_FREEZERS = 'freezers/loadingFreezers'
}